module.exports = __webpack_public_path__ + "img/1548667398.919cd763.jpg";